






























































































































































































import { QuestionType, questionTypes } from '@/types/questionnaire'
import { computed, defineComponent, ref, toRefs } from '@vue/composition-api'
import { useQuestionForm } from '@/composable/questionnaire/useQuestionForm'
import TagCreator from '@/components/organisms/questionnaire/TagCreator.vue'
import { QuestionEntity } from '../../../../api/@types'
import { uploadImage } from '@/api/questionnaire'

type Props = {
  question: QuestionEntity | null
}

export default defineComponent({
  components: { TagCreator },
  props: {
    question: {
      type: Object,
      default: null,
    },
  },
  setup(props: Props, context) {
    const { question } = toRefs(props)
    const { input } = useQuestionForm(question.value)
    const imageUrl = ref('')

    const imageInput = ref({
      imageFile: null as File | null,
    })

    const isCrosses = computed(() =>
      [QuestionType.CROSS_RADIO, QuestionType.CROSS_CHECKBOX].includes(
        input.value?.type,
      ),
    )

    const isSelectors = computed(() =>
      [
        QuestionType.CROSS_RADIO,
        QuestionType.CROSS_CHECKBOX,
        QuestionType.RADIO,
        QuestionType.CHECKBOX,
      ].includes(input.value.type),
    )

    const isText = computed(() =>
      [QuestionType.TEXT, QuestionType.TEXT_AREA].includes(input.value.type),
    )

    const isNumber = computed(() => input.value.type === QuestionType.NUMBER)

    const rules = [(v: any) => !!v || '必須項目です。']

    const addChoice = (inputText: string) => {
      const choices = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(choice =>
          choice
            .trim()
            .replaceAll('\n', '')
            .replaceAll('\t', ''),
        )
        .map(name => ({ name, isLast: false }))
      input.value.choices.push(...choices)
    }

    const addCross = (inputText: string) => {
      const crosses = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(cross =>
          cross
            .trim()
            .replaceAll('\n', '')
            .replaceAll('\t', ''),
        )
        .map(name => ({ name }))
      input.value.crosses.push(...crosses)
    }

    const removeChoice = (index: number) => {
      input.value.choices = input.value.choices.filter((_, i) => i !== index)
    }

    const removeCross = (index: number) => {
      input.value.crosses = input.value.crosses.filter((_, i) => i !== index)
    }

    const removeAllChoices = () => {
      input.value.choices = []
    }

    const removeAllCrosses = () => {
      input.value.crosses = []
    }

    const editChoice = (data: { index: number; name: string }) => {
      input.value.choices = input.value.choices.map((choice, i) => {
        if (i === data.index) {
          return { ...choice, name: data.name.trim() }
        }
        return choice
      })
    }

    const editCross = (data: { index: number; name: string }) => {
      input.value.crosses = input.value.crosses.map((cross, i) => {
        if (i === data.index) {
          return { ...cross, name: data.name.trim() }
        }
        return cross
      })
    }

    const upload = async () => {
      if (!imageInput.value.imageFile) {
        return
      }

      imageUrl.value = await uploadImage(imageInput.value.imageFile)
    }

    const copyUrl = () => {
      if (window.navigator.clipboard === undefined) {
        return
      }
      window.navigator.clipboard.writeText(imageUrl.value || '')
    }

    const save = () => {
      const minLength =
        (isText.value || isNumber.value) && input.value.minLength
          ? input.value.minLength
          : null
      const maxLength =
        (isText.value || isNumber.value) && input.value.maxLength
          ? input.value.maxLength
          : null
      const answerSuffix =
        isNumber.value && input.value.answerSuffix
          ? input.value.answerSuffix
          : null

      context.emit('submit', {
        ...input.value,
        minLength,
        maxLength,
        answerSuffix,
      })
    }

    const cancel = () => {
      context.emit('cancel')
    }

    return {
      input,
      isCrosses,
      isSelectors,
      isText,
      isNumber,
      questionTypes,
      rules,
      imageUrl,
      imageInput,
      addChoice,
      addCross,
      removeChoice,
      removeCross,
      removeAllChoices,
      removeAllCrosses,
      editChoice,
      editCross,
      save,
      cancel,
      upload,
      copyUrl,
    }
  },
})
